import { defineMessages } from "react-intl"

const messages = defineMessages({
  mediaMissing: {
    id: "media.media-missing",
    defaultMessage:
      "We are currently processing this {type}. It will be available shortly."
  },
  dragFile: {
    id: "media-upload.drag-file",
    defaultMessage:
      "Drag your {type} file here, or click to select a {type} file to upload."
  },
  acceptedFiletypes: {
    id: "media-upload.accepted-filetypes",
    defaultMessage: "Accepted filetypes:"
  },
  previewNotAvailable: {
    id: "media-upload.preview-not-available",
    defaultMessage: "Image preview<br/>not available"
  },
  audioNotSupported: {
    id: "media-upload.audio-not-supported",
    defaultMessage: "Sorry, your browser does not support the audio element."
  },
  viewFullPDF: {
    id: "media.view-full-pdf",
    defaultMessage: "View full PDF"
  }
})
export default messages



// WEBPACK FOOTER //
// ./webapp/messages/media.js